<template>
  <label :class="isChecked ? 'fdd-radioy-on' : 'fdd-radioy'" @click="handleClick">
    <i class="use-icon_radio"></i>
    <span class="text">
      <slot>{{ labelText }}</slot>
    </span>
  </label>
</template>
<script>
  export default {
    name: 'FddRadio',
    props: {
      value: {
        type: [String, Number, Boolean]
      },
      label: {
        type: [String, Number, Boolean]
      },
      showLabel: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return { radioGroup: null }
    },
    computed: {
      labelText() {
        if (!this.showLabel) return ''

        return this.label || (this.$slots.default && this.$slots.default[0])
      },
      isChecked() {
        return this.isGroup() ? this.radioGroup.value === this.label : this.value === this.label
      }
    },
    methods: {
      handleClick() {
        if (!this.isChecked) {
          if (this.isGroup()) {
            this.radioGroup.$emit('input', this.label)
            this.radioGroup.$emit('change', this.label)
          } else {
            this.$emit('input', this.label)
            this.$emit('change', this.label)
          }
        }
      },
      isGroup() {
        let parent = this.$parent

        while (parent) {
          if (parent.$options.name !== 'FddRadioGroup') {
            parent = parent.$parent
          } else {
            this.radioGroup = parent
            return true
          }
        }

        return false
      }
    }
  }
</script>
